import { httpService } from '../http.service.js'

export const animeDBService = {
  query,
  getById,
  save,
  remove,
  getByIds,
}

function appendList(params, key, list) {
  if (Array.isArray(list) && list.length) {
    list.forEach(val => params.append(key, val))
  }
}

/**
 * 🔎 שליפת רשימת אנימות
 */
async function query(filterBy = {}) {
  try {
    const params = new URLSearchParams()
    const {
      title,
      title_english,
      title_hebrew,
      year,
      status,
      sort,
      top100,
      excludeMatureContent,
      demographics,
      genres,
      themes,
      score,
      page = 1,
      limit = 30,
    } = filterBy

    if (title) params.set('title', title)
    if (title_english) params.set('title_english', title_english)
    if (title_hebrew) params.set('title_hebrew', title_hebrew)
    if (year) params.set('year', year)
    if (status) params.set('status', status)
    if (sort) params.set('sort', sort)
    if (top100) params.set('top100', top100)

    if (excludeMatureContent !== undefined) {
      params.set('excludeMatureContent', excludeMatureContent)
    }

    appendList(params, 'demographics', demographics)
    appendList(params, 'genres', genres)
    appendList(params, 'themes', themes)
    appendList(params, 'score', score)

    params.set('page', page)
    params.set('limit', limit)

    const res = await httpService.get(`anime?${params.toString()}`)
    return res
  } catch (err) {
    console.error('❌ [animeDBService.query] Failed:', err)
    throw err
  }
}

/**
 * 🔎 שליפת אנימה בודדת לפי מזהה
 */
async function getById(id) {
  try {
    const res = await httpService.get(`anime/${id}`)
    return res
  } catch (err) {
    console.error(`❌ [animeDBService.getById] Failed for id=${id}:`, err)
    throw err
  }
}

/**
 * 💾 הוספה או עדכון אנימה
 */
async function save(anime) {
  try {
    const { mal_id } = anime
    if (mal_id) {
      return await httpService.put(`anime/${mal_id}`, anime)
    } else {
      return await httpService.post('anime', anime)
    }
  } catch (err) {
    console.error('❌ [animeDBService.save] Failed:', err)
    throw err
  }
}

/**
 * 🗑️ מחיקת אנימה
 */
async function remove(id) {
  try {
    const res = await httpService.delete(`anime/${id}`)
    return res
  } catch (err) {
    console.error(`❌ [animeDBService.remove] Failed for id=${id}:`, err)
    throw err
  }
}

/**
 * 🔎 שליפת מספר אנימות לפי מזהים
 * @param {Array} ids - מערך של מזהים (מספרים או ObjectId)
 * @param {boolean} full - האם להביא מידע מלא (default=false)
 */
async function getByIds(ids = [], full = false) {
  try {
    const res = await httpService.post('anime/byIds', { ids, full })
    return res
  } catch (err) {
    console.error('❌ [animeDBService.getByIds] Failed:', err)
    throw err
  }
}
